import { createVuetify, VuetifyOptions } from 'vuetify'
import csmConfig from '@csm/template/vuetify/config'
import { csmMisja } from '@csm/template/brand'

const config: VuetifyOptions = Object.assign(
  {},
  csmConfig,
  {
    ssr: true,
    theme: {
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            primary: csmMisja.primary,
            background: '#fff',
            gray: '#8A94A6',
            'gray-25': '#FCFCFD',
            'gray-50': '#F7F9FC',
            'gray-100': '#EEF2F6',
            'gray-200': '#E3E8EF',
            'gray-300': '#C7D0DD',
            'gray-400': '#8A94A6',
            'gray-500': '#6B7687',
            'gray-600': '#4B5565',
            'gray-700': '#384152',
            'gray-900': '#181C25',
            overlay: '#0E0E0E',
          },
        },
      },
    },
  } satisfies VuetifyOptions
)

export default createVuetify(config)
